import {kSystemIcons} from "../../../constants/icons";
import {useNavigate} from "react-router-dom";
import {kInternalRoutes} from "../../../constants/internalRoutes";

export default function LevelABackToPreviousScreenButton({goBackToPreviousScreen}) {
    // Used in LevelAScreen to display back to previous screen button

    // PROPERTIES
    const navigate = useNavigate()

    // BUILD
    return (
        <div className="cursor-pointer h-[47px] min-h-[47px] flex justify-start items-center space-x-[2px]
             text-greyLight7 hover:text-greyLight9 bg-backgroundLight4 hover:bg-backgroundLight5 rounded-[12px] px-[16px]
             shadow-[inset_0_0_0_1px_#374356]"
            onClick={goBackToPreviousScreen ?? (() => navigate(kInternalRoutes.courses))}>
            <i className={'-ml-[8px] material-icons text-[22px]'}>
                {kSystemIcons.chevronLeft}
            </i>
            <span className={"font-bold whitespace-nowrap text-[14px]"}>
                {"Retour"}
            </span>
        </div>
    );
}